import * as yup from 'yup';
import { currencyFormatter, getMessage } from 'util/locale';
import { formatNumberGrouped } from 'util/formatters/numberFormatter';
import { MULTIPLE_AGRONOMIC_SEASONS_COUNTRIES } from 'constants/advanced';
import { GetSchemaOptions } from '../types';

export const getGlobalInputsSchema = (validateFieldsProperties: boolean, options: GetSchemaOptions) => {
  const { productValidationValues, currency } = options;
  const { GRAIN_PRICE } = productValidationValues?.PLANTING?.CORN || {};

  return {
    grainPrice: validateFieldsProperties
      ? yup
      .number()
      .typeError(getMessage('help-text__value-num', { prop: getMessage('grain-price') }))
      .min(GRAIN_PRICE.min, getMessage('help-text__value-min', {
        prop: getMessage('grain-price'),
        min: currencyFormatter(formatNumberGrouped(GRAIN_PRICE.min), currency)
      }))
      .max(GRAIN_PRICE.max, getMessage('help-text__value-max', {
        prop: getMessage('grain-price'),
        max: currencyFormatter(formatNumberGrouped(GRAIN_PRICE.max), currency)
      }))
      .required(getMessage('help-text__value-required', { prop: getMessage('grain-price') }))
      : yup.number().nullable(),
    plannedPlantingDate: validateFieldsProperties
      ? yup
      .date()
      .required(getMessage('help-text__value-required', { prop: getMessage('planting-date') }))
      : yup.date().nullable(),
    season: validateFieldsProperties
      ? yup
      .string()
      .test(
        'required-for-br',
        getMessage('help-text__value-required', { prop: getMessage('season-variable') }),
        function (value) {
          const fields = this.parent.fields || [];
          const isMultipleAgronomicSeasons = fields.some(
            (field: { countryCode: string }) => MULTIPLE_AGRONOMIC_SEASONS_COUNTRIES.includes(field.countryCode)
          );

          if (isMultipleAgronomicSeasons && !value) {
            return false;
          }
          return true;
        }
      )
      : yup.string().nullable(),
  };
};
